import request from "@/utils/request";

// 列表(主数据列表)
export function systemRolePageListApi(data) {
  return request({
    url: "web/role/listData",
    method: "post",
    data
  });
}
// 导出
export function systemRoleExportListApi(data) {
  return request({
    url: "web/role/exportData",
    method: "post",
    data
  });
}

// 保存
export function systemRoleSaveOrUpdateApi(data) {
  return request({
    url: "web/role/saveOrUpdate",
    method: "post",
    data
  });
}

// 作废
export function systemRoleRemoveApi(data) {
  return request({
    url: "web/role/remove",
    method: "post",
    data
  });
}

// 查看
export function systemRoleInitApi(data) {
  return request({
    url: "web/role/initRole",
    method: "post",
    data
  });
}

// 角色列表（下拉选择）
export function loadRoleListApi(data) {
  return request({
    url: "web/role/findRolesByCondition",
    method: "post",
    data
  });
}

// 权限列表（下拉选择）
export function loadPermissionListApi(data) {
  return request({
    url: "web/permission/findPermissionsByCondition",
    method: "post",
    data
  });
}
// 初始化权限
export function loadPermissionActionMapApi(data) {
  return request({
    url: "web/permission/findChildrenModulesByParentModule",
    method: "post",
    data
  });
}
// 保存角色权限关联
export function saveRolePermissionApi(data) {
  return request({
    url: "web/permission/saveRolePermission",
    method: "post",
    data
  });
}
